<template>
  <div
    v-if="$store.getters.marchand && $store.getters.marchand._env === 'live'"
    class="row"
    style="padding: 5px"
  >
    <loader
      v-show="loader"
      object="#29B3A6"
      color1="#29B3A6"
      color2="#17fd3d"
      size="4"
      speed="5"
      bg="#343a40"
      objectbg="#999793"
      opacity="80"
      name="spinning"
    ></loader>
    <div class="container-fluid" v-if="$store.getters.marchand">
      <div class="col-12 mb-0 pb-0 px-0">
        <v-btn
          @click="$router.go(-1)"
          outlined
          style="border: none; background: #fff"
          title="Retourner"
        >
          <v-icon>mdi mdi-arrow-left-thin</v-icon> Retour
        </v-btn>
      </div>
      <div class="row">
        <div class="col-12 col-lg-8 pt-0 mt-0">
          <v-row v-if="transactions">
            <v-col cols="12" lg="6" md="4" class="mt-0 pt-0">
              <v-card style="padding: 15px">
                <div class="row" style="background: #fff">
                  <div class="col-md-12 pt-2 pb-0">
                    <v-icon large>mdi-account-convert-outline</v-icon>
                  </div>
                  <div class="col-md-12">
                    <div>Information du tuteur:</div>
                    <div style="font-weight: bold">
                      {{
                        transactions[0]._student._firstName +
                        " " +
                        transactions[0]._student._lastName
                      }}
                      <br />
                      {{ transactions[0]._student._phoneNumber }}
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" lg="6" md="4" class="mt-0 pt-0">
              <v-card style="padding: 15px">
                <div class="row" style="background: #fff">
                  <div class="col-md-12 pt-2 pb-0">
                    <v-icon large>mdi-account-multiple-outline</v-icon>
                  </div>
                  <div class="col-md-12">
                    <div>Information de Parent / Tuteur :</div>
                    <div style="font-weight: bold">
                      {{
                        transactions[0]._student._parent._firstName +
                        " " +
                        transactions[0]._student._parent._lastName
                      }}
                      <br />
                      {{ transactions[0]._student._parent._phoneNumber }}
                      /
                      {{ transactions[0]._student._parent._email }}
                      <!-- <a href="#" @click="customer=clients,dialogCustomer=true" class="badge badge-light float-right">plus <v-icon small>mdi-arrow-right-thin</v-icon> </a> -->
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" lg="4" md="4" class="mt-0 pt-0">
              <v-card style="padding: 15px">
                <div class="row" style="background: #fff">
                  <div class="col-md-12 pt-2 pb-0">
                    <v-icon large>mdi-cash-multiple</v-icon>
                  </div>
                  <div class="col-md-12">
                    <div>Montant total dû:</div>
                    <div style="font-weight: bold">
                      {{ transactions[0]._total_to_pay }} XOF
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" lg="4" md="4" class="mt-0 pt-0">
              <v-card style="padding: 15px">
                <div class="row" style="background: #fff">
                  <div class="col-md-12 pt-2 pb-0">
                    <v-icon large>mdi-cash</v-icon>
                  </div>
                  <div class="col-md-12">
                    <div>Montant payer:</div>
                    <div style="font-weight: bold">
                      {{ transactions[0]._total_pay }} XOF
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" lg="4" md="4" class="mt-0 pt-0">
              <v-card style="padding: 15px">
                <div class="row" style="background: #fff">
                  <div class="col-md-12 pt-2 pb-0">
                    <v-icon large>mdi-cash-100</v-icon>
                  </div>
                  <div class="col-md-12">
                    <div>Reste à payer:</div>
                    <div style="font-weight: bold">
                      {{ transactions[0]._remain }} XOF
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" lg="4" md="4" class="mt-0 pt-0">
              <v-card style="padding: 15px">
                <div class="row" style="background: #fff">
                  <div class="col-md-12 pt-2 pb-0">
                    <v-icon large>mdi-numeric-1-box-multiple-outline</v-icon>
                  </div>
                  <div class="col-md-12">
                    <div>programme de paiement:</div>
                    <div style="font-weight: bold">Tranche</div>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" lg="4" md="4" class="mt-0 pt-0">
              <v-card style="padding: 15px">
                <div class="row" style="background: #fff">
                  <div class="col-md-12 pt-2 pb-0">
                    <v-icon large>mdi-satellite-variant</v-icon>
                  </div>
                  <div class="col-md-12">
                    <div>Status global de paiement:</div>
                    <div style="font-weight: bold">
                      <v-chip
                        v-if="transactions[0]._status_payment"
                        class="text-white"
                        small
                        color="green"
                        >payer</v-chip
                      >
                      <v-chip v-else class="text-white" small color="warning">{{
                        "en attente"
                      }}</v-chip>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <div class="col-12 col-lg-4">
          <div class="bg-white p-3">
            <h6 class="col-12">Liste des frais à payer</h6>
            <table class="table table-hover table-striped table-borderless">
              <tr v-for="(fee, index) in transactions[0]._fees" :key="index">
                <td>{{ fee.name }}</td>
                <td class="text-right" style="font-weight: bold">
                  {{ fee.value }} XOF
                </td>
              </tr>
              <tr style="border-top: 1px solid gray">
                <td>Total</td>
                <td class="text-right" style="font-weight: bold">
                  {{ transactions[0]._amount }} XOF
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-0 pt-0">
          <v-card elevation="0">
            <v-data-table
              :headers="headers"
              :items="transactions[0]._payments"
              :items-per-page="15"
              class="elevation-1"
              :loading="loadingTransactions"
              no-data-text="Aucune transaction trouvée"
              :search="search"
            >
              <template v-slot:item._amount="{ item }">
                <strong> {{ formatAmount(item._amount) }} XOF</strong>
              </template>
              <template v-slot:item._reference="{ item }">
                {{ item._transaction._reference }}
              </template>
              <template v-slot:item._created_at="{ item }">
                {{ getDate(item._createdAt) }}
              </template>
              <template v-slot:item._deadline="{ item }">
                {{ getDate(item._deadline) }}
              </template>
              <template v-slot:item._status="{ item }">
                <v-chip
                  class="text-white"
                  small
                  :color="getStatusColor(item._transaction._status).color"
                  >{{
                    getStatusColor(item._transaction._status).status
                  }}</v-chip
                >
              </template>
              <!-- <template v-slot:item._type_programmation="{item}">
                <span class="programm_text text-uppercase">  {{ item._programmation && item._programmation._type_programmation ? item._programmation._type_programmation : 'N/A' }}</span>
                </template> -->
              <template v-slot:item.action="{ item }">
                <div style="text-align: left">
                  <!-- @click="getClientTransactionsData(item)"  -->
                  <a
                    href="#"
                    data-toggle="tooltip"
                    data-placement="right"
                    style="
                      cursor: pointer;
                      background-color: #f5f6fe;
                      padding: 8px;
                      color: black;
                      border-radius: 10px !important;
                      text-decoration: none;
                    "
                    v-clipboard:copy="
                      'https://gateway.intram.org/' +
                      item._transaction._reference
                    "
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    <v-icon style="color: #3c3c3c" small
                      >mdi mdi-content-copy</v-icon
                    >
                  </a>
                </div>
              </template>
              <template v-slot:item.facture="{}">
                <div style="text-align: left">
                  <v-icon small color="black" class="cursor-pointer"
                    >mdi mdi-receipt-text-outline</v-icon
                  >
                </div>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { client } from "../../store/services/client";
import helpers from "../../mixins/helpers";

export default {
  name: "StudentDetails",
  mixins: [helpers(this)],
  data() {
    return {
      dialogCustomer: false,
      loader: false,
      total_pages: 0,
      page: 1,
      openPaiementLogs: false,
      transaction_data: undefined,
      logs_transactions: undefined,
      clients: undefined,
      loadingTransactions: false,
      programmes_transaction: [],
      search: "",
      transactions_tabs: null,
      transactions_headers: [
        { text: "Client", value: "_client" },
        { text: "Actions", value: "_actions" },
      ],
      showPaiementDialog: false,
      transactions: undefined,
      filter: "",
      date: new Date().toISOString().substr(0, 10),
      sum_transaction: 0,
      number_transaction_valid: 0,
      number_transaction_rst: 0,
      sum_valid: 0,
    };
  },
  methods: {
    onCopy: function (e) {
      this.text = this.$t("copie") + e.text;
      this.snackbar = true;
    },
    onError: function () {
      this.text = this.$t("copiefailed");
      this.snackbar = true;
    },
    getMeanName(item) {
      return (
        item.mean._name +
        " " +
        item.mean._country._name +
        " (" +
        item.mean._type +
        ")"
      );
    },
    setDialog() {},
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
    closeLogsTransaction() {
      this.openPaiementLogs = false;
      this.transaction_data = undefined;
      this.logs_transactions = undefined;
    },
    initialize() {
      this.getMarchandClientTransaction();
      //this.getMarchandClientData();
    },
    async getMarchandClientTransaction() {
      // page=page-1;
      this.loadingTransactions = true;
      const response = await client({
        method: "get",
        url: `/school-payments/transactions/student/${this.$route.params.student_id}`,
        // data: {page: page, client : this.$route.query.details }
      })
        .then((res) => res.data)
        .catch((error) => {
          console.log(error);
          return {
            error: true,
          };
        });
      this.loadingTransactions = false;
      if (response && !response.error)
        this.transactions = [
          {
            ...response._transaction,
            _amount: response._amount,
            _fees: response._fees,
            _total_to_pay: response._total_to_pay,
            _total_pay: response._total_pay,
            _remain: response._remain,
            _status_payment: response._status_payment,
          },
        ];
      console.log(response, "**** transaction details");
      this.loader = false;
    },
    async getNumberTransactionValid(arr) {
      let sum = 0,
        valid = 0,
        umpaid = 0,
        sum_valid = 0;
      for (const tr of arr) {
        sum += tr.transaction_data._amount;
        if (tr.transaction_data._status) {
          valid++;
          sum_valid += tr.transaction_data._amount;
        }
        if (tr._number_notification >= 4 && !tr.transaction_data._status) {
          umpaid++;
        }
      }
      this.sum_transaction = sum;
      this.number_transaction_valid = valid;
      this.number_transaction_rst = umpaid;
      this.sum_valid = sum_valid;
    },
    /* async getMarchandClientData() {
      const response = await client({
        method: "get",
        url: `/marchand_customer/get/by/${this.$route.query.details}`,
      })
        .then((res) => res.data)
        .catch((error) => {
          console.log(error);
          return {
            error: true,
          };
        });

      if (response && !response.error) this.clients = response.marchandclient;
      this.loader = false;
      if (this.clients && this.clients.client_transactions) {
        this.getNumberTransactionValid(this.clients.client_transactions);
      }
    }, */
    async getClientTransactionsData(data) {
      this.loader = true;
      let transaction_id = data._id;
      this.transaction_data = data;
      const response = await client({
        method: "post",
        url: `/transactions/get/by/${this.$route.query.details}`,
        data: { transaction_id: transaction_id },
      })
        .then((res) => res.data)
        .catch((error) => {
          console.log(error);
          return {
            error: true,
          };
        });

      if (response && !response.error) {
        this.logs_transactions = response.transactions;
        this.loader = false;
        this.openPaiementLogs = true;
      }
    },
  },
  computed: {
    headers: function () {
      return [
        { text: "", value: "facture" },
        { text: "", value: "action" },
        { text: "", value: "_payment_name" },
        { text: "Référence", value: "_reference" },

        { text: "Statut", value: "_status" },
        { text: "Date limit de paiement", value: "_deadline" },
        // {text: 'Référence', value: '_reference'},
        // {text: 'Nom', value: '_name'},
        { text: "Montant à payer", value: "_amount" },
        { text: "Créer le", value: "_created_at" },
      ];
    },
  },
  created() {
    this.loader = true;
    this.checkisDashboard();
    this.initialize();
  },
};
</script>

<style scoped></style>
